const isValidElement = (object) => typeof object === "object" && typeof object?.key !== "undefined" && typeof object?.props !== "undefined";
export {
  isValidElement
};
//# sourceMappingURL=isValidReactElement.mjs.map